import { Injectable } from '@angular/core';
import { ProductAnalyticsService } from '@vendasta/product-analytics';
import { Properties } from 'posthog-js';
import { ObjectType } from '../tokens-and-interfaces';

@Injectable()
export class CRMTrackingService {
  private eventName = 'crm';

  constructor(private readonly trackingService: ProductAnalyticsService) {}

  trackEvent(objectType: ObjectType, action: string, properties?: Properties): void {
    this.trackingService.trackEvent(
      this.eventName,
      `${this.eventName}-${objectType?.toLowerCase()}`,
      action,
      0,
      properties,
    );
  }
}
